<h3 *ngIf="playerMode" class="title t-player" [innerHTML]="'FEATURES.TITLES.PLAYER' | translate"></h3>
<h3 *ngIf="teamMode" class="title t-team" [innerHTML]="'FEATURES.TITLES.TEAM' | translate"></h3>

<div class="features-wrap" [ngClass]="{'gipant-mode': giPantMode, 'henterpant-mode': henterPantMode, 'end-consumer': endConsumerMode, 'team': teamMode, 'player': playerMode}">
  <ul class="features-tabs">
    <li *ngFor="let tabItem of tabs" [ngClass]="{'active': tabItem.active}"
        (click)="selectTab(tabItem)">
      <p>{{tabItem.tab}}</p>
    </li>
  </ul>
  <div class="tab-content">
    <div class="app-wrap">
      <div class="app" *ngIf="activeTab" [ngStyle]="{'background-image': 'url(' + activeTab.gif + ')'}"></div>
    </div>

    <div class="description" *ngIf="activeTab">
      <h4 class="sub-title">{{activeTab.title}}</h4>

      <ng-container *ngIf="playerMode && activeTab.tab === ('FEATURES.PLAYER.TAB_3_TITLE' | translate); else defaultTemplate">
        <h5 [innerHTML]="'FEATURES.PLAYER.TAB_3_1_INFO' | translate"></h5>

        <p class="title-list" [innerHTML]="'FEATURES.PLAYER.TAB_3_2_INFO' | translate"></p>
        <ul>
          <li [innerHTML]="'FEATURES.PLAYER.TAB_3_3_INFO' | translate"></li>
          <li [innerHTML]="'FEATURES.PLAYER.TAB_3_4_INFO' | translate"></li>
        </ul>

        <p class="title-list" [innerHTML]="'FEATURES.PLAYER.TAB_3_5_INFO' | translate"></p>
        <ul>
          <li [innerHTML]="'FEATURES.PLAYER.TAB_3_6_INFO' | translate"></li>
          <li [innerHTML]="'FEATURES.PLAYER.TAB_3_7_INFO' | translate"></li>
        </ul>

        <p class="title-list" [innerHTML]="'FEATURES.PLAYER.TAB_3_8_INFO' | translate"></p>
        <ul>
          <li [innerHTML]="'FEATURES.PLAYER.TAB_3_9_INFO' | translate"></li>
          <li [innerHTML]="'FEATURES.PLAYER.TAB_3_10_INFO' | translate"></li>
        </ul>
      </ng-container>


      <ng-template #defaultTemplate>
        <ng-container *ngIf="Array.isArray(activeTab.info); else singleInfo">
          <div *ngFor="let paragraph of activeTab.info">
            <p [innerHTML]="paragraph"></p>
          </div>
        </ng-container>

        <ng-template #singleInfo>
          <p [innerHTML]="activeTab.info"></p>
        </ng-template>
      </ng-template>

    </div>
  </div>
</div>
